import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-px-sm" }
const _hoisted_2 = { class: "text-h6 text-navy-700" }
const _hoisted_3 = { class: "text-inactive" }
const _hoisted_4 = { class: "text-h6 text-navy-700 q-pt-md" }
const _hoisted_5 = { class: "text-inactive" }
const _hoisted_6 = { class: "text-h6 text-navy-700 q-pt-md" }

import { is } from "quasar"
import SfxFormSubmit from "src/components/special/SfxFormSubmit.vue"
import SfxToggleSettings from "src/components/toggle/SfxToggleSettings.vue"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useUserStore } from "src/stores/userStore"
import { DarkModeOption, WorkActionOption } from "src/util/enums/configuration"
import { showEasterEggNotification } from "src/util/functions/notifications"
import { UserCurrent } from "src/util/types/dataModels/user"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsConfiguration',
  setup(__props) {

const { t } = useI18n()
const configurationStore = useConfigurationStore()
const userStore = useUserStore()

// Get and set current values of all toggles

const originalConfig = computed(() => configurationStore.getCurrentConfiguration)
const currentConfig = ref({ ...originalConfig.value })
const isEqualToOriginal = computed(() => is.deepEqual(originalConfig.value, currentConfig.value))

// Sections titles

const firstSectionTitle = t("sfxDialogUserSettings.title_workflow")
const secondSectionTitle = t("sfxDialogUserSettings.title_data_transfer")
const thirdSectionTitle = t("sfxDialogUserSettings.title_other")

// Main description of all toggles

const workOrdersDescription = t("sfxDialogUserSettings.work_orders")
const issuesDescription = t("sfxDialogUserSettings.issues")
const performedWorkDescription = t("sfxDialogUserSettings.performed_work")
const skipListDescription = t("sfxDialogUserSettings.skip_list")
const locationSelectItemDescription = t("sfxDialogUserSettings.location_select")
const internetDescription = t("sfxDialogUserSettings.internet_connectivity")
const prioritizeDataDescription = t("sfxDialogUserSettings.prioritize_data")
const downloadAllDescription = t("sfxDialogUserSettings.download_all_data")
const notificationsDescription = t("sfxDialogUserSettings.notifications")
const darkModeDescription = t("sfxDialogUserSettings.dark_mode")
const tutorialDescription = t("sfxDialogUserSettings.tutorial")

// Secondary description (blue label) of toggles

const trinaryTrueLabel = t("sfxDialogUserSettings.trinary_true_label")
const trinaryFalseLabel = t("sfxDialogUserSettings.trinary_false_label")
const trinaryIndeterminateLabel = t("sfxDialogUserSettings.trinary_indeterminate_label")
const locationSelectItemTrueLabel = t("sfxDialogUserSettings.location_select_true_label")
const locationSelectItemFalseLabel = t("sfxDialogUserSettings.location_select_false_label")
const internetTrueLabel = t("sfxDialogUserSettings.internet_true_label")
const internetItemFalseLabel = t("sfxDialogUserSettings.internet_false_label")
const darkModeTrueLabel = t("sfxDialogUserSettings.dark_mode_true_label")
const darkModeFalseLabel = t("sfxDialogUserSettings.dark_mode_false_label")
const darkModeIndeterminateLabel = t("sfxDialogUserSettings.dark_mode_indeterminate_label")
const easterEggsTrueLabel = t("sfxDialogUserSettings.easterEggs_true_label")
const easterEggsFalseLabel = t("sfxDialogUserSettings.easterEggs_false_label")

//endregion

//region Functions

function discardData() {
  currentConfig.value = { ...originalConfig.value }
}

async function submitData() {
  if (
    originalConfig.value.easterEggs !== currentConfig.value.easterEggs &&
    currentConfig.value.easterEggs
  ) {
    showEasterEggNotification(t("sfxDialogUserSettings.easterEgg_notification"))
  }
  const userData: Partial<UserCurrent> = { settings: { data: currentConfig.value } }
  await userStore.uploadUserData(userData)
}

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(firstSectionTitle)), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("time.coming_soon")), 1),
    _createVNode(SfxToggleSettings, {
      html: "",
      trinary: "",
      modelValue: currentConfig.value.workOrderDefaultAction,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentConfig.value.workOrderDefaultAction) = $event)),
      description: _unref(workOrdersDescription),
      "true-value": _unref(WorkActionOption).PERFORM,
      "true-label": _unref(trinaryTrueLabel),
      "false-value": _unref(WorkActionOption).OPEN,
      "false-label": _unref(trinaryFalseLabel),
      "indeterminate-value": _unref(WorkActionOption).CHOOSE,
      "indeterminate-label": _unref(trinaryIndeterminateLabel),
      disable: ""
    }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"]),
    _createVNode(SfxToggleSettings, {
      html: "",
      trinary: "",
      modelValue: currentConfig.value.issueDefaultAction,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentConfig.value.issueDefaultAction) = $event)),
      description: _unref(issuesDescription),
      "true-value": _unref(WorkActionOption).PERFORM,
      "true-label": _unref(trinaryTrueLabel),
      "false-value": _unref(WorkActionOption).OPEN,
      "false-label": _unref(trinaryFalseLabel),
      "indeterminate-value": _unref(WorkActionOption).CHOOSE,
      "indeterminate-label": _unref(trinaryIndeterminateLabel),
      disable: ""
    }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"]),
    _createVNode(SfxToggleSettings, {
      html: "",
      modelValue: currentConfig.value.autoCompleteWork,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentConfig.value.autoCompleteWork) = $event)),
      description: _unref(performedWorkDescription),
      disable: ""
    }, null, 8, ["modelValue", "description"]),
    _createVNode(SfxToggleSettings, {
      modelValue: currentConfig.value.skipListWithSingleItem,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentConfig.value.skipListWithSingleItem) = $event)),
      description: _unref(skipListDescription),
      disable: ""
    }, null, 8, ["modelValue", "description"]),
    _createVNode(SfxToggleSettings, {
      html: "",
      modelValue: currentConfig.value.locationSelectItem,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentConfig.value.locationSelectItem) = $event)),
      description: _unref(locationSelectItemDescription),
      "true-label": _unref(locationSelectItemTrueLabel),
      "false-label": _unref(locationSelectItemFalseLabel),
      disable: ""
    }, null, 8, ["modelValue", "description", "true-label", "false-label"]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(secondSectionTitle)), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("time.coming_soon")), 1),
    _createVNode(SfxToggleSettings, {
      modelValue: currentConfig.value.internetConnectivity,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentConfig.value.internetConnectivity) = $event)),
      description: _unref(internetDescription),
      "true-label": _unref(internetTrueLabel),
      "false-label": _unref(internetItemFalseLabel),
      disable: ""
    }, null, 8, ["modelValue", "description", "true-label", "false-label"]),
    _createVNode(SfxToggleSettings, {
      html: "",
      modelValue: currentConfig.value.prioritizeData,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentConfig.value.prioritizeData) = $event)),
      description: _unref(prioritizeDataDescription),
      disable: ""
    }, null, 8, ["modelValue", "description"]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(thirdSectionTitle)), 1),
    _createVNode(SfxToggleSettings, {
      modelValue: currentConfig.value.downloadDataOnStartUp,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentConfig.value.downloadDataOnStartUp) = $event)),
      description: _unref(downloadAllDescription)
    }, null, 8, ["modelValue", "description"]),
    _createVNode(SfxToggleSettings, {
      modelValue: currentConfig.value.animateNotification,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentConfig.value.animateNotification) = $event)),
      description: _unref(notificationsDescription)
    }, null, 8, ["modelValue", "description"]),
    _createVNode(SfxToggleSettings, {
      html: "",
      trinary: "",
      modelValue: currentConfig.value.darkMode,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentConfig.value.darkMode) = $event)),
      description: _unref(darkModeDescription),
      "true-value": _unref(DarkModeOption).ON,
      "true-label": _unref(darkModeTrueLabel),
      "false-value": _unref(DarkModeOption).OFF,
      "false-label": _unref(darkModeFalseLabel),
      "indeterminate-value": _unref(DarkModeOption).SYSTEM,
      "indeterminate-label": _unref(darkModeIndeterminateLabel),
      disable: ""
    }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"]),
    _createVNode(SfxToggleSettings, {
      modelValue: currentConfig.value.tutorial,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((currentConfig.value.tutorial) = $event)),
      description: _unref(tutorialDescription),
      disable: ""
    }, null, 8, ["modelValue", "description"]),
    _createVNode(SfxToggleSettings, {
      modelValue: currentConfig.value.easterEggs,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((currentConfig.value.easterEggs) = $event)),
      description: currentConfig.value.easterEggs ? _unref(easterEggsTrueLabel) : _unref(easterEggsFalseLabel)
    }, null, 8, ["modelValue", "description"]),
    (!isEqualToOriginal.value)
      ? (_openBlock(), _createBlock(SfxFormSubmit, {
          key: 0,
          onDiscard: discardData,
          onSubmit: submitData,
          "target-class": "scroll-box"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})